var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCopySimple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-CopySimple"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.3998 4H3.39978C3.26717 4 3.14 4.05268 3.04623 4.14645C2.95246 4.24021 2.89978 4.36739 2.89978 4.5V13.5C2.89978 13.6326 2.95246 13.7598 3.04623 13.8536C3.14 13.9473 3.26717 14 3.39978 14H12.3998C12.5324 14 12.6596 13.9473 12.7533 13.8536C12.8471 13.7598 12.8998 13.6326 12.8998 13.5V4.5C12.8998 4.36739 12.8471 4.24021 12.7533 4.14645C12.6596 4.05268 12.5324 4 12.3998 4ZM11.8998 13H3.89978V5H11.8998V13ZM14.8998 2.5V11.5C14.8998 11.6326 14.8471 11.7598 14.7533 11.8536C14.6596 11.9473 14.5324 12 14.3998 12C14.2672 12 14.14 11.9473 14.0462 11.8536C13.9525 11.7598 13.8998 11.6326 13.8998 11.5V3H5.39978C5.26717 3 5.14 2.94732 5.04623 2.85355C4.95246 2.75979 4.89978 2.63261 4.89978 2.5C4.89978 2.36739 4.95246 2.24021 5.04623 2.14645C5.14 2.05268 5.26717 2 5.39978 2H14.3998C14.5324 2 14.6596 2.05268 14.7533 2.14645C14.8471 2.24021 14.8998 2.36739 14.8998 2.5Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopySimple);
export default __webpack_public_path__ + "static/media/Icon-CopySimple.1b41359a66f6806c67f13c14d18d30eb.svg";
export { ForwardRef as ReactComponent };